var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionsActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.571,
    height: 19.571,
    viewBox: "0 0 19.571 19.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6089",
    "data-name": "Group 6089",
    transform: "translate(0.022 -0.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6090",
    "data-name": "Group 6090",
    transform: "translate(-0.022 0.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M27.979,47A.979.979,0,1,1,27,47.98.978.978,0,0,1,27.979,47",
    transform: "translate(-18.193 -31.67)",
    fill: "#5186ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M24.29,18.1a1.52,1.52,0,0,1,.721-1.354A3.588,3.588,0,1,0,20.2,11.8a.979.979,0,0,0,.851,1.465,1,1,0,0,0,.855-.506,1.631,1.631,0,0,1,3.011,1.093,1.671,1.671,0,0,1-.858,1.191,3.455,3.455,0,0,0-1.729,3.066v.375a.979.979,0,1,0,1.957,0Z",
    transform: "translate(-13.526 -6.738)",
    fill: "#5186ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M48.537,3.588A3.588,3.588,0,0,0,44.949,0h-.923a1.018,1.018,0,0,0-1.034.881.994.994,0,0,0,.979,1.076h.979A1.631,1.631,0,0,1,46.58,3.588v.923a1.018,1.018,0,0,0,.881,1.034.978.978,0,0,0,1.072-.876.9.9,0,0,0,0-.1Z",
    transform: "translate(-28.966 0)",
    fill: "#5186ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M1.076,5.546a1.018,1.018,0,0,0,.881-1.034V3.589A1.631,1.631,0,0,1,3.588,1.958h.923a1.018,1.018,0,0,0,1.034-.881A.978.978,0,0,0,4.669.006a.9.9,0,0,0-.1,0H3.588A3.588,3.588,0,0,0,0,3.589v.979a.978.978,0,0,0,.974.983.9.9,0,0,0,.1,0",
    transform: "translate(0 -0.001)",
    fill: "#5186ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M0,44.958a3.588,3.588,0,0,0,3.588,3.588h.923a1.018,1.018,0,0,0,1.034-.881.978.978,0,0,0-.876-1.071.9.9,0,0,0-.1,0H3.588a1.631,1.631,0,0,1-1.631-1.631v-.923A1.018,1.018,0,0,0,1.076,43h-.1A.988.988,0,0,0,0,43.98Z",
    transform: "translate(0 -28.975)",
    fill: "#5186ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M48.537,43.969a.978.978,0,0,0-.974-.983.9.9,0,0,0-.1,0,1.018,1.018,0,0,0-.881,1.034v.923a1.631,1.631,0,0,1-1.631,1.631h-.923a1.018,1.018,0,0,0-1.034.881.994.994,0,0,0,.979,1.076h.979a3.588,3.588,0,0,0,3.588-3.588Z",
    transform: "translate(-28.966 -28.965)",
    fill: "#5186ec"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionsActive);
export default __webpack_public_path__ + "static/media/questions-active.03892a64f3d5311f87c3696264f95ba4.svg";
export { ForwardRef as ReactComponent };